export var MetricExportDestinationType;
(function (MetricExportDestinationType) {
    MetricExportDestinationType["METRIC_EXPORT_DESTINATION_TYPE_GROUNDCOVER_OTLP"] = "GROUNDCOVER_OTLP";
})(MetricExportDestinationType || (MetricExportDestinationType = {}));
